module.exports = __webpack_public_path__ + "img/zghsj.213b9698.png";